export default (state) => requiredFeatures => {
    return requiredFeatures.reduce((bool, item) => bool || !!state.features.find(i => item === i), false);
}